export default __webpack_public_path__ + "0b4bc5925de64ebe36bf344845de3d5d.png";